import { Box, Center, Flex, IconButton, Spinner, Text, Textarea, VStack } from "@chakra-ui/react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Message } from "@twilio/conversations";
import UserAvatar from "components/elements/UserAvatar";
import { ChatContext } from "providers/chat";
import { MessagesContext } from "providers/messages";
import { useContext, useState, useRef } from "react";
import { toggleAccountType } from "utils/helpers";
import ChatBox from "../ChatBox";
import { useTenant } from "modules/tenant/providers/tenant-provider";

const CurrentConversation = ({ conversation }: { conversation: any }) => {
  const bottomRef = useRef<null | HTMLDivElement>(null);
  const [body, setBody] = useState("");
  const [sending, setSending] = useState(false);

  const { user } = useTenant();
  const { initialized } = useContext(ChatContext);
  const { messages, send } = useContext(MessagesContext);

  async function sendMessage() {
    try {
      setSending(true);
      await send(body, conversation[toggleAccountType(user.type)].id);
      setBody("");
    } catch (error) {
      console.error(error);
    } finally {
      setSending(false);
    }
  }

  return initialized && conversation ? (
    <VStack w="100%">
      <Box w="100%" py="24px" px="30px" borderBottomColor="gray.50" borderBottomWidth="1px">
        <Flex alignItems="center">
          <UserAvatar size="51px" mr="20px" user={conversation.participant} />
          <Flex flexDir="column" ml="20px" lineHeight="28px">
            <Text fontWeight="600" fontSize="20px">
              {`${conversation.participant.first_name} ${conversation.participant.last_name}`}
            </Text>
            <Text fontSize="16px" color="#B8BCC0" mt="0px">
              {conversation.participant.tagline}
            </Text>
          </Flex>
        </Flex>
      </Box>
      <Box flexGrow="1" w="100%" pt="40px" pr="40px" pl="40px" overflowY="scroll">
        {(messages[conversation.id] || []).map((message: Message) => (
          <ChatBox key={message.sid} isAuthor={message.author === user.id} message={message} />
        ))}
        {(messages[conversation.id] || []).length === 0 && (
          <Center w="100%">
            <Text color="#515355" fontSize="14px">
              No messages, yet!
            </Text>
          </Center>
        )}
        <div ref={bottomRef} />
      </Box>
      {conversation.participant.is_active && (
        <Box p="20px" borderTopColor="gray.50" borderTopWidth="1px" w="100%">
          <Flex alignItems="center">
            <Textarea
              onChange={ev => setBody(ev.target.value)}
              value={body}
              fontSize="16px"
              placeholder="Write a message..."
              w="100%"
              rows={2}
              border="none"
            />
            <Box>
              <IconButton
                aria-label="send-message"
                w="41px"
                h="41px"
                onClick={sendMessage}
                isDisabled={sending}
                borderRadius="50%"
                icon={
                  <Box ml="-3px">
                    <FontAwesomeIcon icon={["far", "paper-plane"]} />
                  </Box>
                }
              />
            </Box>
          </Flex>
        </Box>
      )}
    </VStack>
  ) : (
    <Center w="100%">
      <Spinner />
    </Center>
  );
};

export default CurrentConversation;
